import Axios from 'axios'
import Cache from '../lib/cache'

const OEMBED_API_DOMAIN = 'https://noembed.com'
const OEMBED_PROVIDERS_ENDPOINT = '/providers'
const OEMBED_EMBED_ENDPOINT = '/embed'
const OEMBED_CACHE_KEY = 'oembed'

const CACHE = new Cache(OEMBED_CACHE_KEY)

export const URL_TEST = /^https?:\/\/[^\s$.?#].[^\s]*$/g

export default {
  install(Vue) {
    const $noembed = {
      providers: null,
      async getProviders() {
        try {
          const res = await Axios.get(
            `${OEMBED_API_DOMAIN}${OEMBED_PROVIDERS_ENDPOINT}`,
          )
          this.providers = res.data
        } catch (err) {
          console.error(err)
          return []
        }
        return this.providers
      },
      async isEmbed(url) {
        const patterns = this.providers.map(({ pattern }) => pattern)
        return patterns.reduce((acc, cur) => acc || cur.test(url))
      },
      async getEmbed(url) {
        let embed
        let res
        // prevent blank urls
        if (typeof url !== 'string') throw new Error('invalid url')

        // todo: test url against providers data

        // cache check
        const cache = CACHE.get()
        const encodedUri = encodeURIComponent(url)
        if (cache[encodedUri]) {
          console.debug(
            'cache oembed found for ' + decodeURIComponent(encodedUri),
          )
          return cache[encodedUri]
        }

        // eslint-disable-next-line no-useless-catch
        try {
          res = await Axios.get(
            `${OEMBED_API_DOMAIN}${OEMBED_EMBED_ENDPOINT}`,
            {
              params: {
                url,
              },
            },
          )
        } catch (err) {
          throw err
        }

        const { data } = res
        if (data.error) {
          throw data.error
        }

        cache[encodedUri] = embed = data
        CACHE.set(cache)

        return embed
      },
    }
    Vue.prototype.$noembed = $noembed
  },
}
